import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import Sidebar from '../../components/Sidebar';
import './movimentacao.css';
import { useInternals } from '../../context/internalContext';
import { useUsers } from '../../context/usersContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import FormattedInput from '../../components/FormatdInput/formatFunctions';
import Modal from '../../components/modal/';
import AddVisitorOthers from '../Visitantes/outrosVisitantes';
import Webcam from 'react-webcam';
import ImgPlaceholder from '../../assets/icons/imgplaceholder.svg';
import { normalizeUnitId } from '../../utils/unitScope';

function Moviment() {
  const NO_LINKED_INTERNAL_OPTION = '__none__';
  const TYPE_VISIT_INTIMA = 'INTIMA';
  const TYPE_VISIT_INTIMO = 'INTIMO';
  const TYPE_VISIT_INFANTIL = 'INFANTIL';
  const TYPE_VISIT_SOCIAL_PRESENCIAL = 'SOCIAL PRESENCIAL';
  const FAMILY_ALLOWED_VISITOR_TYPES = new Set(['FAMILIAR', 'INFANTIL']);
  const SOCIAL_ALLOWED_VISITOR_TYPES = new Set(['FAMILIAR']);
  const INTIMA_REQUIRED_VISITOR_TYPES = new Set(['FAMILIAR', 'INTIMA']);
  const NO_TYPE_VISIT_ALLOWED_VISITOR_TYPES = new Set([
    'ADVOGADO',
    'POLICIAL',
    'PROMOTOR DE JUSTICA',
    'MEMBRO DO MINISTERIO PUBLICO',
    'JUIZ',
    'DEFENSOR PUBLICO',
    'MEMBRO DA DEFENSORIA PUBLICA',
    'RELIGIOSO',
    'TERCEIRIZADO',
    'OUTROS SERVICOS',
  ]);
  const NO_TYPE_VISIT_WITH_INTERNAL_ALLOWED_VISITOR_TYPES = new Set([
    'ADVOGADO',
    'POLICIAL',
    'PROMOTOR DE JUSTICA',
    'MEMBRO DO MINISTERIO PUBLICO',
    'JUIZ',
    'DEFENSOR PUBLICO',
    'MEMBRO DA DEFENSORIA PUBLICA',
  ]);
  const NEED_RELATION_VISITOR_TYPES = new Set(['FAMILIAR', 'INFANTIL', 'INTIMA']);
  // Trechos que identificam SOMENTE o erro de trava por irregularidade da OAB no
  // Cadastro Nacional (não confundir com validações de formulário que também citam
  // "OAB", ex.: UF da OAB obrigatória). Basta um dos trechos aparecer na mensagem.
  const OAB_BLOCK_ERROR_HINTS = [
    'NAO ESTA REGULAR NO SISTEMA DA OAB',
    'PENDENCIA NO CADASTRO NACIONAL OAB',
  ];

  const { createMoviment, updateMovimentRegister, getVisitors, getVisitorById, listInternals } = useInternals();
  const { listTypeVisits } = useAuxiliaries();

  const {
    effectiveUnitId,
    buildUnitReadParams,
    requireWriteUnit,
  } = useUsers();

  const [visitorName, setVisitorName] = useState('');
  const [visitorSuggestions, setVisitorSuggestions] = useState([]);
  const [visitorId, setVisitorId] = useState('');
  const [selectedVisitor, setSelectedVisitor] = useState(null);

  const [internalName, setInternalName] = useState('');
  const [internalSuggestions, setInternalSuggestions] = useState([]);
  const [selectedInternals, setSelectedInternals] = useState([]); // Lista de internos selecionados
  const [linkedInternals, setLinkedInternals] = useState([]);
  const [linkedInternalSelection, setLinkedInternalSelection] = useState('');
  const [isLoadingLinkedInternals, setIsLoadingLinkedInternals] = useState(false);
  const [isLoadingInternals, setIsLoadingInternals] = useState(false);

  const [purposeVisit, setPurposeVisit] = useState('');
  const [movementType, setMovementType] = useState('Entrada');
  const [selectedTypeVisitId, setSelectedTypeVisitId] = useState('');
  const [typeVisitOptions, setTypeVisitOptions] = useState([]);
  const [registerFile, setRegisterFile] = useState(null);
  const [registerPreview, setRegisterPreview] = useState('');
  const [showRegisterWebcam, setShowRegisterWebcam] = useState(false);
  const [registerCameraError, setRegisterCameraError] = useState('');
  const registerFileInputRef = useRef(null);
  const registerWebcamRef = useRef(null);

  // Removido: estados de busca e datas de filtro

  const [isLoading, setIsLoading] = useState(false);
  const [isVisitorModalOpen, setIsVisitorModalOpen] = useState(false);
  const [skipOabCheck, setSkipOabCheck] = useState(false);
  const [showOabBypass, setShowOabBypass] = useState(false);
  const normalizeText = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();

  const getVisitorTypeNames = (visitor) => {
    if (!visitor) return [];
    const list = [];

    if (Array.isArray(visitor.type_visitor)) {
      visitor.type_visitor.forEach((item) => {
        const name = typeof item === 'string' ? item : item?.name;
        if (name) list.push(name);
      });
    } else if (visitor.type_visitor?.name) {
      list.push(visitor.type_visitor.name);
    } else if (typeof visitor.type_visitor === 'string') {
      list.push(visitor.type_visitor);
    }

    if (visitor.type_visitor_detail?.name) {
      list.push(visitor.type_visitor_detail.name);
    }

    return [...new Set(list.map((name) => normalizeText(name)).filter(Boolean))];
  };

  const selectedTypeVisit = useMemo(
    () => typeVisitOptions.find((option) => String(option.id) === String(selectedTypeVisitId)) || null,
    [typeVisitOptions, selectedTypeVisitId]
  );

  const normalizedSelectedTypeVisit = normalizeText(selectedTypeVisit?.type);

  useEffect(() => {
    const fetchTypeVisits = async () => {
      try {
        const response = await listTypeVisits();
        const options = Array.isArray(response?.results)
          ? response.results
          : (Array.isArray(response) ? response : []);
        setTypeVisitOptions(options);
      } catch (error) {
        setTypeVisitOptions([]);
      }
    };

    fetchTypeVisits();
  }, [listTypeVisits]);

  const getInternalUnitId = (internal) => normalizeUnitId(
    internal?.unit?.id ?? internal?.unit_id ?? internal?.unit
  );

  const getAllowedVisitorTypesByTypeVisit = (normalizedTypeVisit) => {
    if (normalizedTypeVisit === TYPE_VISIT_INFANTIL) return FAMILY_ALLOWED_VISITOR_TYPES;
    if (normalizedTypeVisit === TYPE_VISIT_SOCIAL_PRESENCIAL) return SOCIAL_ALLOWED_VISITOR_TYPES;
    if (normalizedTypeVisit === TYPE_VISIT_INTIMA || normalizedTypeVisit === TYPE_VISIT_INTIMO) {
      return INTIMA_REQUIRED_VISITOR_TYPES;
    }
    return null;
  };

  const validateEntryRules = ({ visitor, selectedInternalIds }) => {
    if (visitor?.authorize_entry === false) {
      return 'Visitante não tem autorização para entrar na unidade.';
    }

    const visitorTypeNames = getVisitorTypeNames(visitor);
    let visitorTypesForRelation = [];

    if (!normalizedSelectedTypeVisit) {
      const allowedVisitorTypes = selectedInternalIds.length > 0
        ? NO_TYPE_VISIT_WITH_INTERNAL_ALLOWED_VISITOR_TYPES
        : NO_TYPE_VISIT_ALLOWED_VISITOR_TYPES;
      const hasAllowedType = visitorTypeNames.some((name) => allowedVisitorTypes.has(name));
      visitorTypesForRelation = visitorTypeNames.filter((name) => allowedVisitorTypes.has(name));

      if (!hasAllowedType) {
        return 'Visitante ainda não é classificado para esse tipo de visita.';
      }
    } else {
      const allowedVisitorTypes = getAllowedVisitorTypesByTypeVisit(normalizedSelectedTypeVisit);
      const matchedVisitorTypes = allowedVisitorTypes
        ? visitorTypeNames.filter((name) => allowedVisitorTypes.has(name))
        : [];
      visitorTypesForRelation = matchedVisitorTypes;

      if (
        normalizedSelectedTypeVisit === TYPE_VISIT_INTIMA
        || normalizedSelectedTypeVisit === TYPE_VISIT_INTIMO
      ) {
        const hasIntimaType = visitorTypeNames.includes('INTIMA') || visitorTypeNames.includes('INTIMO');
        if (!hasIntimaType) {
          return 'Visitante ainda não é classificado para esse tipo de visita.';
        }
      } else if (allowedVisitorTypes && matchedVisitorTypes.length === 0) {
        return 'Visitante ainda não é classificado para esse tipo de visita.';
      }

      if (
        normalizedSelectedTypeVisit === TYPE_VISIT_INFANTIL
        && selectedInternalIds.length === 0
      ) {
        return 'É obrigatório informar ao menos um interno para esse tipo de visita.';
      }

      if (matchedVisitorTypes.includes('FAMILIAR')) {
        const socialWorkerStatus = normalizeText(visitor?.social_worker_authorization);
        if (socialWorkerStatus !== 'AUTORIZADO') {
          return 'Visitante não tem permissão para visitar internos.';
        }
      }
    }

    if (selectedInternalIds.length > 0) {
      const hasNeedRelationType = visitorTypesForRelation
        .some((typeName) => NEED_RELATION_VISITOR_TYPES.has(typeName));
      if (hasNeedRelationType) {
        const linkedIds = new Set(linkedInternals.map((internal) => String(internal?.id)));
        if (linkedIds.size === 0) {
          return 'Visitante não tem relação com nenhum dos internos.';
        }
        const hasInternalWithoutRelation = selectedInternalIds
          .some((internalId) => !linkedIds.has(String(internalId)));
        if (hasInternalWithoutRelation) {
          return 'Visitante não tem relação com um ou mais internos selecionados.';
        }
      }
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);

    if (!visitorId) {
      toast.error('Por favor, selecione um visitante.');
      setIsLoading(false);
      return;
    }

    if (!purposeVisit.trim()) {
      toast.error('Informe a finalidade da visita.');
      setIsLoading(false);
      return;
    }

    const writeUnit = requireWriteUnit();
    if (!writeUnit.ok) {
      toast.warning(writeUnit.message);
      setIsLoading(false);
      return;
    }

    const hasInternalsFromOtherUnit = selectedInternals.some((internal) => {
      const internalUnitId = getInternalUnitId(internal);
      if (internalUnitId === null) return false;
      return String(internalUnitId) !== String(writeUnit.unitId);
    });

    if (hasInternalsFromOtherUnit) {
      toast.warning('Existem internos fora da unidade de atuação selecionada.');
      setIsLoading(false);
      return;
    }

    const selectedInternalIds = [
      ...new Set(
        selectedInternals
          .map((internal) => internal?.id)
          .filter((id) => id !== null && id !== undefined && String(id).trim() !== '')
      ),
    ];

    const entryValidationError = validateEntryRules({
      visitor: selectedVisitor,
      selectedInternalIds,
    });
    if (entryValidationError) {
      toast.warning(entryValidationError);
      setIsLoading(false);
      return;
    }

    const isFamiliar = Array.isArray(selectedVisitor?.type_visitor)
      && selectedVisitor.type_visitor.some((item) => normalizeText(item?.name) === 'FAMILIAR');
    const isFamiliarWithInternal = isFamiliar && selectedInternalIds.length > 0;

    const payloadBase = {
      visitor: visitorId,
      observations: purposeVisit.trim(),
      moviment: movementType,
      unit: writeUnit.unitId,
      internal: selectedInternalIds,
    };

    if (isFamiliarWithInternal) {
      // Familiar com interno: envia type_visit selecionado no select, sem purpose_visit
      if (selectedTypeVisitId) {
        payloadBase.type_visit = Number(selectedTypeVisitId);
      }
    } else {
      // Familiar sem interno ou não-familiar: envia purpose_visit com o nome do tipo não-familiar
      const autoType = Array.isArray(selectedVisitor?.type_visitor)
        ? selectedVisitor.type_visitor.find((t) => t?.name && normalizeText(t.name) !== 'FAMILIAR')
        : null;
      const purposeName = autoType?.name || selectedVisitor?.type_visitor?.[0]?.name || '';
      if (purposeName) {
        payloadBase.purpose_visit = purposeName;
      }
    }

    // Advogado com OAB inválida por erro de sistema: operador marca o check para
    // registrar a entrada sem consultar a OAB; enviamos check=false para liberar.
    const submitVisitorIsLawyer = getVisitorTypeNames(selectedVisitor).includes('ADVOGADO');
    if (submitVisitorIsLawyer && skipOabCheck) {
      payloadBase.check = false;
    }

    try {
      const createdMoviment = await createMoviment(payloadBase);

      if (createdMoviment?.error) {
        const normalizedErrorMessage = normalizeText(createdMoviment.message);
        const isOabBlockError = OAB_BLOCK_ERROR_HINTS
          .some((hint) => normalizedErrorMessage.includes(hint));
        if (submitVisitorIsLawyer && !skipOabCheck && isOabBlockError) {
          setShowOabBypass(true);
          toast.warning('Não foi possível validar a OAB do advogado. Para registrar a entrada sem consultar a OAB, marque a opção abaixo e salve novamente.');
        }
        return;
      }

      if (!createdMoviment?.id) {
        return;
      }

      if (registerFile) {
        await updateMovimentRegister(createdMoviment.id, registerFile);
      }

      setVisitorName('');
      setVisitorId('');
      setSelectedVisitor(null);
      setVisitorSuggestions([]);
      setPurposeVisit('');
      setMovementType('Entrada');
      setSelectedTypeVisitId('');
      setInternalName('');
      setInternalSuggestions([]);
      setSelectedInternals([]); // Limpa a lista de internos selecionados
      setLinkedInternals([]);
      setLinkedInternalSelection('');
      setRegisterFile(null);
      setRegisterPreview('');
      setShowRegisterWebcam(false);
      setRegisterCameraError('');
      setSkipOabCheck(false);
      setShowOabBypass(false);
    } catch (error) {
      console.error('Erro ao adicionar movimentação:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Removido: função applyFilters

  const getVisitorTypeLabel = (visitor) => {
    if (!visitor) return '';
    if (typeof visitor.type_visitor === 'string') return visitor.type_visitor;
    if (Array.isArray(visitor.type_visitor)) {
      return visitor.type_visitor.map((item) => item?.name).filter(Boolean).join(', ');
    }
    if (visitor.type_visitor?.name) return visitor.type_visitor.name;
    if (visitor.type_visitor_detail?.name) return visitor.type_visitor_detail.name;
    return '';
  };

  const getVisitorAccessStatus = (visitor) => {
    if (!visitor) {
      return { label: 'NAO LIBERADO', className: 'status-nao-liberado', canProceed: false };
    }

    if (visitor.authorize_entry === true) {
      return { label: 'LIBERADO', className: 'status-liberado', canProceed: true };
    }

    const discipline = normalizeText(visitor.discipline_authorization);
    const socialWorker = normalizeText(visitor.social_worker_authorization);
    const hasTechnicalAuthorization = discipline === 'AUTORIZADO' && socialWorker === 'AUTORIZADO';

    if (visitor.authorize_entry === false) {
      return { label: 'BLOQUEADO', className: 'status-bloqueado', canProceed: false };
    }

    if (hasTechnicalAuthorization) {
      return { label: 'PENDENTE DE LIBERACAO', className: 'status-nao-liberado', canProceed: false };
    }

    return { label: 'NAO LIBERADO', className: 'status-nao-liberado', canProceed: false };
  };

  const getInternalVisitStatus = (internal) => {
    if (!internal || internal.visit === undefined || internal.visit === null) {
      return null;
    }

    if (internal.visit === false) {
      return { label: 'BLOQUEADO', className: 'status-bloqueado' };
    }

    return { label: 'LIBERADO', className: 'status-liberado' };
  };

  const hasLetters = (value) => /[a-zA-ZÀ-ÿ]/.test(value || '');
  const isCpfSearchMode = (value) => !hasLetters(value) && (value || '').replace(/\D/g, '').length > 0;

  // Carregar visitantes (com busca paginada e parâmetro de nome)
  const handleVisitorSearch = async (query) => {
    setVisitorName(query);
    setVisitorId('');
    setSelectedVisitor(null);
    setSelectedTypeVisitId('');
    setSelectedInternals([]);
    setLinkedInternals([]);
    setLinkedInternalSelection('');
    setSkipOabCheck(false);
    setShowOabBypass(false);

    const cpfDigits = (query || '').replace(/\D/g, '');

    if (isCpfSearchMode(query)) {
      if (cpfDigits.length >= 11) {
        try {
          const response = await getVisitors({ cpf: cpfDigits });

          if (response && Array.isArray(response.results)) {
            setVisitorSuggestions(response.results);
          } else {
            setVisitorSuggestions([]);
          }
        } catch (error) {
          console.error('Erro ao buscar visitantes por CPF:', error);
          setVisitorSuggestions([]);
        }
      } else {
        setVisitorSuggestions([]);
      }
      return;
    }

    if (query.length >= 3) {
      try {
        const params = { name: query };
        const response = await getVisitors(params);

        if (response && Array.isArray(response.results)) {
          setVisitorSuggestions(response.results);
        } else {
          setVisitorSuggestions([]);
        }
      } catch (error) {
        console.error('Erro ao buscar visitantes:', error);
      }
    } else {
      setVisitorSuggestions([]);
    }
  };

  const hydrateLinkedInternal = useCallback(async (internalData) => {
    const internalId = internalData?.id;
    if (!internalId) return null;

    try {
      const response = await listInternals(buildUnitReadParams({ id: internalId }));
      const found = response?.results?.[0];
      if (found) return found;
    } catch (error) {
      // segue com fallback de dados mínimos
    }

    return {
      id: internalId,
      name: internalData?.name || '',
      cpf: internalData?.cpf || '',
      unit_name: internalData?.unit_name || '',
      pavilion_name: internalData?.pavilion_name || '',
      cell_name: internalData?.cell_name || '',
    };
  }, [listInternals, buildUnitReadParams]);

  const handleSelectVisitor = async (visitor) => {
    setVisitorId(visitor.id);
    setSelectedVisitor(visitor);
    setVisitorName(visitor.name);
    setSelectedTypeVisitId('');
    setVisitorSuggestions([]); // limpa sugestões após seleção
    setSelectedInternals([]);
    setInternalName('');
    setInternalSuggestions([]);
    setLinkedInternalSelection('');
    setSkipOabCheck(false);
    setShowOabBypass(false);

    const visitorInternals = Array.isArray(visitor?.internals) ? visitor.internals : [];
    if (!visitorInternals.length) {
      setLinkedInternals([]);
      return;
    }

    setIsLoadingLinkedInternals(true);
    try {
      const hydrated = await Promise.all(
        visitorInternals.map((internalData) => hydrateLinkedInternal(internalData))
      );

      const uniqueById = [];
      hydrated.filter(Boolean).forEach((internalData) => {
        if (!uniqueById.some((item) => String(item.id) === String(internalData.id))) {
          uniqueById.push(internalData);
        }
      });
      setLinkedInternals(uniqueById);
    } finally {
      setIsLoadingLinkedInternals(false);
    }
  };

  const handleVisitorCreated = async (createdVisitor) => {
    setIsVisitorModalOpen(false);
    setVisitorSuggestions([]);

    if (!createdVisitor) {
      return;
    }

    try {
      let visitorToSelect = createdVisitor;

      if (createdVisitor?.id) {
        const fetchedVisitor = await getVisitorById(createdVisitor.id);
        if (fetchedVisitor?.id) {
          visitorToSelect = fetchedVisitor;
        }
      } else if (createdVisitor?.name) {
        const searchedVisitors = await getVisitors({ name: createdVisitor.name });
        const visitorResults = Array.isArray(searchedVisitors?.results) ? searchedVisitors.results : [];
        if (visitorResults.length > 0) {
          const byCpf = visitorResults.find(
            (item) => String(item?.cpf || '') === String(createdVisitor?.cpf || '')
          );
          visitorToSelect = byCpf || visitorResults[0];
        }
      }

      if (visitorToSelect?.id) {
        await handleSelectVisitor(visitorToSelect);
        setVisitorName(visitorToSelect.name || '');
        setSelectedTypeVisitId('');
      } else if (createdVisitor?.name) {
        setVisitorName(createdVisitor.name);
        setSelectedTypeVisitId('');
      }
    } catch (error) {
      console.error('Erro ao selecionar visitante recém-cadastrado:', error);
      if (createdVisitor?.name) {
        setVisitorName(createdVisitor.name);
      }
    }
  };

  // Carregar internos (com busca paginada e parâmetro de nome). Debounce: só consulta a API quando o
  // usuário para de digitar; resposta de um termo antigo que chegar atrasada é ignorada.
  useEffect(() => {
    const query = internalName.trim();
    if (linkedInternals.length > 0 || query.length < 3) {
      setInternalSuggestions([]);
      setIsLoadingInternals(false);
      return undefined;
    }

    let isCurrent = true;
    setIsLoadingInternals(true);
    const timer = setTimeout(async () => {
      try {
        const params = buildUnitReadParams({ name: query });
        const response = await listInternals(params);
        if (!isCurrent) return;

        if (response && Array.isArray(response.results)) {
          setInternalSuggestions(response.results);
        } else {
          setInternalSuggestions([]);
        }
      } catch (error) {
        console.error('Erro ao buscar internos:', error);
      } finally {
        if (isCurrent) setIsLoadingInternals(false);
      }
    }, 400);

    return () => {
      isCurrent = false;
      clearTimeout(timer);
    };
  }, [internalName, linkedInternals.length, listInternals, buildUnitReadParams]);

  const handleSelectInternal = (internal) => {
    if (!internal?.id) return;
    if (selectedInternals.some((item) => item.id === internal.id)) {
      toast.warn('Este interno já foi adicionado.');
      return;
    }

    setSelectedInternals((prev) => [...prev, internal]);
    setInternalName('');
    setInternalSuggestions([]);
  };

  const handleSelectLinkedInternal = (internalId) => {
    setLinkedInternalSelection(internalId);

    if (internalId === NO_LINKED_INTERNAL_OPTION) {
      setSelectedInternals([]);
      setInternalName('');
      setInternalSuggestions([]);
      return;
    }

    if (!internalId) return;

    const selectedInternal = linkedInternals.find(
      (internal) => String(internal.id) === String(internalId)
    );
    if (selectedInternal) {
      handleSelectInternal(selectedInternal);
    }
    setLinkedInternalSelection('');
  };

  const handleRemoveInternal = (id) => {
    setSelectedInternals(selectedInternals.filter((internal) => internal.id !== id));
  };
  
  const stopStreamTracks = (stream) => {
    try {
      stream.getTracks().forEach((track) => track.stop());
    } catch (error) {
      // noop
    }
  };

  const openRegisterCapture = async () => {
    if (showRegisterWebcam) return;
    setRegisterCameraError('');

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      registerFileInputRef.current?.click();
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
      stopStreamTracks(stream);
      setShowRegisterWebcam(true);
    } catch (error) {
      registerFileInputRef.current?.click();
    }
  };

  const handleRegisterFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    setRegisterFile(file);
    setShowRegisterWebcam(false);
    setRegisterCameraError('');

    if (!file) {
      setRegisterPreview('');
      return;
    }

    if (file.type?.startsWith('image/')) {
      setRegisterPreview(URL.createObjectURL(file));
    } else {
      setRegisterPreview('');
    }
  };

  const captureRegisterFromWebcam = async () => {
    if (!registerWebcamRef.current) return;
    const imageSrc = registerWebcamRef.current.getScreenshot();
    if (!imageSrc) return;

    const response = await fetch(imageSrc);
    const blob = await response.blob();
    const file = new File([blob], 'registro_movimentacao.jpg', { type: 'image/jpeg' });
    setRegisterFile(file);
    setRegisterPreview(URL.createObjectURL(file));
    setShowRegisterWebcam(false);
    setRegisterCameraError('');
  };

  const cancelRegisterWebcam = () => {
    setShowRegisterWebcam(false);
    setRegisterCameraError('');
  };

  const visitorCpfDigits = (visitorName || '').replace(/\D/g, '');
  const canShowVisitorResults = isCpfSearchMode(visitorName)
    ? visitorCpfDigits.length >= 11
    : visitorName.length >= 3;
  const selectedVisitorStatus = getVisitorAccessStatus(selectedVisitor);

  const visitorIsFamiliar = Array.isArray(selectedVisitor?.type_visitor)
    && selectedVisitor.type_visitor.some(
      (item) => normalizeText(item?.name) === 'FAMILIAR'
    );
  const hasInternals = Array.isArray(selectedInternals) && selectedInternals.length > 0;
  const showTypeVisit = visitorIsFamiliar && hasInternals;
  const visitorIsLawyer = getVisitorTypeNames(selectedVisitor).includes('ADVOGADO');

  useEffect(() => {
    if (!showTypeVisit) {
      setSelectedTypeVisitId('');
    }
  }, [showTypeVisit]);

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container'>
        <Titulo
          children={
            <h2>Cadastrar Entrada de visitante</h2>
          }
        />

        <div className='content'>
          <form className='social-form-busca-intern' onSubmit={handleSubmit}>
            <div style={{ width: '100%' }}>
              <Titulo
                children={
                  <h4 style={{ color: 'var(--azul)' }}>Criar Movimentação</h4>
                }
                children2={
                  <button
                    type='submit'
                    className='submit-button-moviment'
                    style={{ width: '100%' }}
                    disabled={isLoading}
                  >
                    {isLoading ?
                      'Carregando...'
                      :
                      'SALVAR'
                    }
                  </button>
                }
              />
            </div>

            {(!effectiveUnitId && effectiveUnitId !== 0) && (
              <small className="movement-search-help">
                Não foi possível identificar a unidade do usuário.
              </small>
            )}

            <div className='form-group container-reults-moviments'>
              <label htmlFor='movement-visitor-search' className='movement-field-label'>
                Visitante
              </label>
              {isCpfSearchMode(visitorName) ? (
                <FormattedInput
                  id='movement-visitor-search'
                  type='cpf'
                  placeholder='Buscar visitante por CPF'
                  value={visitorName}
                  onChange={(e) => handleVisitorSearch(e.target.value)}
                  className='form-input'
                />
              ) : (
                <FormattedInput
                  id='movement-visitor-search'
                  type='nome'
                  placeholder='Buscar visitante'
                  value={visitorName}
                  onChange={(e) => handleVisitorSearch(e.target.value)}
                  className='form-input'
                />
              )}
              <small className="movement-search-help">
                Você pode buscar por nome ou CPF.
              </small>
              {selectedVisitor && (
                <small className="movement-search-help">
                  Status para visita:{' '}
                  <span className={`movement-visitor-status ${selectedVisitorStatus.className}`}>
                    {selectedVisitorStatus.label}
                  </span>
                </small>
              )}
              {canShowVisitorResults && (
                <div className='moviment-search-results'>
                  {visitorSuggestions.length > 0 ? (
                    visitorSuggestions.map((visitor) => {
                      const status = getVisitorAccessStatus(visitor);
                      return (
                        <div
                          key={visitor.id}
                          onClick={() => handleSelectVisitor(visitor)}
                          className='moviment-search-result-item'
                        >
                          {visitor.name} - {visitor.cpf} - Tipo de entrada: {getVisitorTypeLabel(visitor) || 'N/A'} -{' '}
                          <span className={`movement-visitor-status ${status.className}`}>
                            {status.label}
                          </span>
                        </div>
                      );
                    })
                  ) : visitorId === '' ? (
                    <div className='moviment-search-result-item'>
                      <p>Visitante não encontrado.</p>
                      <br />
                      <button
                        className='btnAdcionarVisitor'
                        onClick={(e) => {
                          e.preventDefault();
                          setIsVisitorModalOpen(true);
                        }}
                      >
                        + Adicionar novo visitante
                      </button>
                    </div>
                  ) : null}
                </div>
              )}
            </div>

            <div className='form-group moviment-search-container'>
              <label
                htmlFor={linkedInternals.length > 0 ? 'movement-linked-internal' : 'movement-internal-search'}
                className='movement-field-label'
              >
                Interno relacionado
              </label>
              {linkedInternals.length > 0 ? (
                <>
                  <select
                    id='movement-linked-internal'
                    value={linkedInternalSelection}
                    onChange={(e) => handleSelectLinkedInternal(e.target.value)}
                    className='form-select'
                    disabled={isLoadingLinkedInternals}
                  >
                    <option value=''>
                      {isLoadingLinkedInternals
                        ? 'Carregando internos vinculados...'
                        : 'Selecione um interno relacionado do visitante'}
                    </option>
                    <option value={NO_LINKED_INTERNAL_OPTION}>
                      Nenhum interno relacionado
                    </option>
                    {linkedInternals.map((internal) => {
                      const internalStatus = getInternalVisitStatus(internal);
                      return (
                        <option key={internal.id} value={internal.id}>
                          {internal.name}{internalStatus ? ` — ${internalStatus.label}` : ''}
                        </option>
                      );
                    })}
                  </select>
                  <small className="movement-search-help">
                    Este visitante possui internos vinculados. Selecione um deles para registrar a movimentação.
                  </small>
                </>
              ) : (
                <>
                  <FormattedInput
                    id='movement-internal-search'
                    type='nome'
                    placeholder='Buscar Interno por Nome'
                    value={internalName}
                    onChange={(e) => setInternalName(e.target.value)}
                    className='form-input'
                  />
                  {isLoadingInternals && (
                    <div className='moviment-search-results-internal'>
                      <div className='moviment-search-result-internal-item moviment-loading-item'>
                        Buscando internos...
                      </div>
                    </div>
                  )}
                  {!isLoadingInternals && internalSuggestions.length > 0 && (
                    <div className='moviment-search-results-internal'>
                      {internalSuggestions.map((internal) => (
                        <div
                          key={internal.id}
                          onClick={() => handleSelectInternal(internal)}
                          className='moviment-search-result-internal-item'
                        >
                          <div className='internal-suggestion-row'>
                            <span className='internal-suggestion-name'>{internal.name}</span>
                            {internal.cpf && (
                              <span className='internal-suggestion-cpf'>{internal.cpf}</span>
                            )}
                          </div>
                          {(internal.pavilion_name || internal.cell_name) && (
                            <div className='internal-suggestion-tags'>
                              {internal.pavilion_name && (
                                <span className='internal-suggestion-tag'>{internal.pavilion_name}</span>
                              )}
                              {internal.cell_name && (
                                <span className='internal-suggestion-tag'>{internal.cell_name}</span>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Lista de internos selecionados */}
            <table className='selected-internals-table'>
              <thead>
                <tr>
                  <th>Interno</th>
                  <th>CPF</th>
                  <th>Pavilhão</th>
                  <th>Cela</th>
                  <th></th>
                </tr>
              </thead>
              {selectedInternals.length > 0 ? (
                selectedInternals.map((internal) => (
                  <tbody key={internal.id}>
                    <tr>
                      <td>{internal.name}</td>
                      <td>{internal.cpf}</td>
                      <td>{internal.pavilion_name || '—'}</td>
                      <td>{internal.cell_name || '—'}</td>
                      <td>
                        <button
                          type='button'
                          onClick={() => handleRemoveInternal(internal.id)}
                          className='remove-button'
                        >
                          X
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ))
              ) : (
                <tbody>
                  <tr>
                    <td className='semDados' colSpan='5'>Nenhum interno selecionado.</td>
                  </tr>
                </tbody>
              )}
            </table>

            {showTypeVisit && (
              <div className='form-group'>
                <label htmlFor='movement-type-visit' className='movement-field-label'>
                  Tipo de visita
                </label>
                <select
                  id='movement-type-visit'
                  value={selectedTypeVisitId}
                  onChange={(e) => setSelectedTypeVisitId(e.target.value)}
                  className='form-select'
                >
                  <option value=''>Sem tipo de visita</option>
                  {typeVisitOptions
                    .filter((tv) => !normalizeText(tv.type || '').includes('VIRTUAL'))
                    .filter((tv) => normalizeText(tv.type || '') !== 'FAMILIAR')
                    .map((typeVisit) => (
                      <option key={typeVisit.id} value={typeVisit.id}>
                        {typeVisit.type}
                      </option>
                    ))}
                </select>
                <small className="movement-search-help">
                  Para visitas com familiar, selecione o tipo de visita para aplicar as regras de autorização.
                </small>
              </div>
            )}

            {showOabBypass && visitorIsLawyer && (
              <div className='form-group movement-oab-bypass'>
                <label className='movement-oab-bypass-label'>
                  <input
                    type='checkbox'
                    checked={skipOabCheck}
                    onChange={(e) => setSkipOabCheck(e.target.checked)}
                  />
                  <span>Registrar entrada sem consultar a OAB</span>
                </label>
                <small className='movement-search-help'>
                  A validação da OAB do advogado falhou. Marque esta opção para liberar
                  o registro da entrada sem consultar a OAB e salve novamente.
                </small>
              </div>
            )}

            <div className='form-group-large movement-purpose-group'>
              <label htmlFor='movement-purpose' className='movement-field-label'>
                Finalidade da visita
              </label>
              <textarea
                id='movement-purpose'
                placeholder='Finalidade da visita'
                value={purposeVisit}
                onChange={(e) => setPurposeVisit(e.target.value)}
                className='form-textarea'
                required
              />
            </div>

            <div className='form-group movement-register-group'>
              <label className='movement-register-label'>Registro fotográfico da entrada</label>
              <p className='movement-register-help'>Adicione foto ou documento de comprovação da movimentação.</p>

              <div
                className={`movement-register-upload ${showRegisterWebcam ? 'webcam-active' : ''}`}
                onClick={openRegisterCapture}
              >
                <input
                  ref={registerFileInputRef}
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={handleRegisterFileChange}
                  className="image-input"
                  capture="environment"
                  style={{ display: 'none' }}
                />

                {showRegisterWebcam ? (
                  <div className="movement-register-webcam" onClick={(e) => e.stopPropagation()}>
                    <Webcam
                      ref={registerWebcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{ facingMode: { ideal: 'environment' } }}
                      onUserMediaError={() =>
                        setRegisterCameraError('Não foi possível acessar a câmera. Verifique as permissões.')
                      }
                    />
                    <div className="movement-register-actions">
                      <button type="button" className="btn-primary" onClick={captureRegisterFromWebcam}>
                        Tirar foto
                      </button>
                      <button
                        type="button"
                        className="btn-secondary"
                        onClick={() => registerFileInputRef.current?.click()}
                      >
                        Escolher arquivo
                      </button>
                      <button type="button" className="btn-secondary" onClick={cancelRegisterWebcam}>
                        Cancelar
                      </button>
                    </div>
                    {registerCameraError && (
                      <p className="camera-error">{registerCameraError}</p>
                    )}
                  </div>
                ) : (
                  registerPreview ? (
                    <img
                      src={registerPreview}
                      alt="Prévia do registro fotográfico"
                      className="movement-register-preview"
                    />
                  ) : (
                    <div className="movement-register-placeholder">
                      <img src={ImgPlaceholder} alt="Adicionar registro fotográfico" className="upload-icon" />
                      <span>
                        {registerFile
                          ? `Arquivo selecionado: ${registerFile.name || 'arquivo'}`
                          : 'Adicionar imagem'}
                      </span>
                    </div>
                  )
                )}
              </div>
            </div>

          </form>
        </div>

      </div>
      <Modal isOpen={isVisitorModalOpen} closeModal={() => setIsVisitorModalOpen(false)}>
        <AddVisitorOthers
          onSuccess={handleVisitorCreated}
        />
      </Modal>
    </div>
  );
}

export default Moviment;
